import { useEffect, useMemo, useRef, useState } from "react";
import {
    useMeeting,
    usePubSub,
    useParticipant,
} from "@videosdk.live/react-sdk";

import ReactPlayer from "react-player";

// CSS
import styled from 'styled-components';
import '../../styles/videoconference.css'

import Swal from "sweetalert2";


const VideoContainer = styled.div`
`;

const RoundedReactPlayer = styled(ReactPlayer)`
`;


const ParticipantView = (props) => {
 
    // FOR IMAGE CAPTURE
    const { publish } = usePubSub('IMAGE_CAPTURE');
    const { isLocal } = useParticipant(props.participantId);

    const { participants } = useMeeting({});


    const { localParticipant } = useMeeting();

 
    const { toggleMic, toggleWebcam} = useMeeting();
  

    function sendRequest() {
        // Pass the participantId of the participant whose image you want to capture
        // Here, it will be Participant B's id, as you want to capture the the image of Participant B
        publish("Sending request to capture image", { persist: false, sendOnly: [props.participantId] });
      };


    const micRef = useRef(null);
    const { webcamStream, micStream, webcamOn, micOn, displayName, captureImage } = useParticipant(props.participantId);

    const videoStream = useMemo(() => {
        if (webcamOn && webcamStream) {
            const mediaStream = new MediaStream();
            mediaStream.addTrack(webcamStream.track);
            return mediaStream;
        }
    }, [webcamStream, webcamOn]);

 


    useEffect(() => {
        if (micRef.current) {
            if (micOn && micStream) {
                const mediaStream = new MediaStream();
                mediaStream.addTrack(micStream.track);

                micRef.current.srcObject = mediaStream;
                micRef.current
                    .play()
                    .catch((error) =>
                        console.error("videoElem.current.play() failed", error)
                    
                    );
            } else {
                micRef.current.srcObject = null;
            }
        }
    }, [micStream, micOn]);




    const [imageList, setImageList] = useState([]);
    const [adminData, setAdminData] = useState("");
    const [affiantElements, setAffiantElements] = useState([]);

 
    const [isCapturedAdmin,setIsCapturedAdmin] = useState(false);
    const [isCapturedAllAffiants,setIsCapturedAllAffiants] = useState(false);
  
    async function imageCapture(displayName, participantId) {

    
        
        console.log("Button clicked!", displayName, participantId);
      if (webcamOn && webcamStream) {
        const base64 = await captureImage();

        const img = new Image();
        img.src = 'data:image/jpeg;base64,' + base64;
    
        img.onload = () => {
            // Create a canvas element
            const canvas = document.createElement('canvas');
            
            // Set canvas dimensions to desired cropped size
            const centerWidth = 600; // Desired width of the center region
            const centerHeight = 1000; // Desired height of the center region
            canvas.width = centerWidth;
            canvas.height = centerHeight;
    
            const ctx = canvas.getContext('2d');
    
            // Calculate the coordinates for the center crop
            const startX = (img.width - centerWidth) / 2;
            const startY = (img.height - centerHeight) / 2;
    
            // Draw the center cropped region onto the canvas
            ctx.drawImage(img, startX, startY, centerWidth, centerHeight, 0, 0, centerWidth, centerHeight);
    
            // Convert the canvas to base64
            const croppedBase64Data = canvas.toDataURL('image/jpeg').split(',')[1];

            
            
            if (displayName === "OATH ADMIN") {
                setAdminData(croppedBase64Data);
                handleInputChange(croppedBase64Data)
                props.handleAdminBase64(croppedBase64Data)

                
                setIsCapturedAdmin(true)
              }
 
        };










      
      } else {
        console.error("Camera must be on to capture an image");
      }
    }

    const [inputValue, setInputValue] = useState('');
    const handleInputChange = (value) => {
        setInputValue(value);
      };
  
    
    async function imageCaptureAffiant(displayName, participantId,adminBase64Image) {
      if (webcamOn && webcamStream) {
        const base64 = await captureImage();

        // if (displayName === "OATH ADMIN") {
        //     setAdminData(base64);
        //   }

        //   else{
            setImageList((prevImages) => [
                // ...prevImages,
                { participantId, base64,adminBase64Image }
              ]);
         // }


         
       
      } else {
        console.error("Camera must be on to capture an image");
      }
    }


    const btnCaptureAdminRef = useRef(null);
    const captureAllParticipantsImages = () => {

        if(!isCapturedAdmin){
 
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "You must Capture the Administrative Image first.",
                footer: '<a href="#">Please do the step 1.</a>'
              });

            return;
        }

        btnCaptureAdminRef.current.click();
        props.clearArray([])

        for (const participantId of participants.keys()) {
            const captureButton = document.getElementById(`btn_getimage_${participantId}`);
            if (captureButton) {
                captureButton.click();
            }
        }

        setIsCapturedAllAffiants(true)
    };

 
   

    const [mergedData, setMergedData] = useState([]);
    const mergeArrays = () => {

        console.log("imageList",imageList);

        const filtered = imageList.map(imageItem => {
            const transactionItem = props.transactionsForOath.find(transaction => transaction.transaction_id === imageItem.participantId);
            return transactionItem ? { ...transactionItem, ...imageItem } : null;
        }).filter(item => item !== null);
    
        
        
        props.handleMergedData(filtered)
      };

 
      useEffect(()=>{
        mergeArrays()
      },[imageList])


      const handleReload = () => {
        Swal.fire({
            title: 'Before reloading the page, make sure you send all the certificates.',
            text: 'Do you want to reload the page ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: 'btn-danger',
            cancelButtonColor: 'btn-secondary',
            confirmButtonText: 'Yes, reload!',
            cancelButtonText: 'No, cancel',
            confirmButtonColor: '#03c3ec',
            cancelButtonColor: '#ff3e1d',
          }).then((result) => {
            if (result.isConfirmed) {
                window.location.reload()
            }
          });
      }
 
    return (

        <>

            {isLocal &&
              <div className="row">
                  <div className="col mb-2 p-0">
                    <div className="card h-100">
                        <div className="card-body no-shadow">
                            <div className="row">
                                <div className="col d-flex justify-content-center  rounded py-0 ps-0">
                                    {webcamOn ? (
                                        <VideoContainer className={`${isLocal ? "video-container" : "video-container-affiant"} `} >
                                            <RoundedReactPlayer
                                                playsinline
                                                pip={false}
                                                light={false}
                                                controls={false}
                                                muted={true}
                                                playing={true}
                                                url={videoStream}
                                                onError={(err) => {
                                                    console.log(err, "participant video error");
                                                }}

                                                style={{
                                                    backgroundColor: "#1c1c1c",
                                                }}

                                                className="w-100"
                                            />
                                        </VideoContainer>
                                    )
                                    :
                                    

                                    

                                            <div className="container-fluid full-height d-flex align-items-center justify-content-center border rounded">
                                                <div className="text-center">
                                                    <h2>Camera is turned-off</h2>
                                                    <p>Turn-on your camera.</p>
                                                    <i className='bx bxs-camera-off fs-1' ></i>
                                                </div>
                                            </div>

                                    
                                }

                                     

                                        <div className=" d-flex justify-content-center bottom-0 position-absolute mb-5 btn-group">
                                            <button className="btn btn-sm btn-label-info" onClick={() => toggleMic()}>Microphone: {micOn ? <i className='bx bxs-microphone'></i> : <i className='bx bxs-microphone-off'></i>}</button>
                                            <button className="btn btn-sm btn-label-info" onClick={() => toggleWebcam()}>Webcam: {webcamOn ? <i className='bx bxs-camera' ></i> : <i className='bx bxs-camera-off' ></i>}</button> 
                                        </div>
                                        <audio ref={micRef} autoPlay playsInline muted={isLocal} />



                                </div>
                                <div className="col border rounded position-relative">
                                    <div className="card-header d-flex justify-content-center">
                                        <div>
                                            <h5 className="card-title mb-1">{displayName}</h5>
                                        </div>
                                    </div>
                                    <div className="row card-body">
                                        {isLocal &&
                                            <>
                                                <div className="mb-2">
                                                    <span className="d-block fw-bolder text-black">Step 1</span>
                                                    <div className="d-flex">
                                                        <button ref={btnCaptureAdminRef} className="btn btn-sm btn-label-info" onClick={() => { imageCapture(displayName, props.participantId) }}>Capture Administrative Image</button>
                                                        {isCapturedAdmin &&
                                                            <span className="badge badge-center bg-success ms-2" title="Status"><i className="bx bx-check"></i></span>
                                                         }
                                                    </div>
                                                </div>

                                                

                                                <div className="mb-2">
                                                    <span className="d-block fw-bolder text-black">Step 2</span>
                                                  

                                                    <div className="d-flex">

                                                        <button className="btn btn-sm btn-label-info" onClick={() => {
                                                            imageCapture(displayName, props.participantId);
                                                            captureAllParticipantsImages();
                                                        }}>Capture All Affiants Image
                                                        </button>
                                                       
                                                        {isCapturedAllAffiants &&
                                                            <span className="badge badge-center bg-success ms-2" title="Status"><i className="bx bx-check"></i></span>
                                                         }
                                                    </div>
                                                </div>

                                                <span className="fw-bolder text-black mt-2">Step 3</span>
                                                <span>On the <span className="text-danger fw-bold">bottom of your screen</span>, scroll down and Click "Send Certificate" to each affiant.</span>


                                                <span className="fw-bolder text-black mt-2">Step 4</span>
                                                <span className="text-danger fw-bold">When all of the certificates were successfully sent, then,</span>



                                                <div className="mb-2">
                                                    <span className="d-block fw-bolder text-black">Step 5</span>
                                                  

                                                    <div className="d-flex">

                                                        <button className="btn btn-sm btn-label-info" >Clean </button> <span className="fw-bold text-black mx-3"> or </span> <button className="btn btn-sm btn-label-info" onClick={handleReload} >Reload Page. </button>
                                                 
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {!isLocal && <button id={`btn_getimage_${props.participantId}`} className="btn btn-info" onClick={() => { imageCaptureAffiant(displayName, props.participantId, props.adminBase64Image); }}>Recapture Affiant Image</button>}
                                    </div>
                                   
                                </div>
                            </div>
                        </div>
                    </div>


                    {/* <div>
                {images.map(({ participantId, base64 }) => (
                    <div key={participantId}>
                        <p>{participantId}</p>
                        <img src={`data:image/jpeg;base64,${base64}`} alt="Captured" />
                    </div>
                ))}
            </div> * <button onClick={async () => {
                    if (!isLocal) {
                        sendRequest();
                    }
                }}>Capture Image</button> */}

                </div>
              </div>
            }

            <div className="row">
                {!isLocal &&

                    <div className="col-4 mb-2 p-0">
                        <div className="card h-100">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col d-flex  rounded py-2 position-relative">


                                        <span className="badge rounded-pill bg-info position-absolute mt-1 ms-1" style={{ zIndex: 1 }}>{displayName}</span>

                                        {webcamOn ? (
                                            <VideoContainer className={`${isLocal ? "video-container border" : "video-container-affiant border z-index-n1"} `} >
                                                <RoundedReactPlayer
                                                    playsinline
                                                    pip={false}
                                                    light={false}
                                                    controls={false}
                                                    muted={true}
                                                    playing={true}
                                                    url={videoStream}
                                                    onError={(err) => {
                                                        console.log(err, "participant video error");
                                                    }}

                                                    style={{
                                                        backgroundColor: "#1c1c1c",
                                                    }}

                                                    className="w-100"
                                                />
                                            </VideoContainer>
                                        ) 
                                    :
                                            <div className="container-fluid full-height d-flex align-items-center justify-content-center border rounded" style={{minHeight:300}}>
                                                <div className="text-center">
                                                    <span className="text-primary  fw-bold border border-dashed border-primary rounded-3 text-center fs-5 mt-4 p-4">
                                                        {isLocal && "Your "}Camera is turned-off
                                                    </span>
                                                    <i className='bx bxs-camera-off fs-1' ></i>
                                                </div>
                                            </div>

                                    }


                                    </div>



                                    <div className=" d-flex justify-content-center mt-n2 bg-white rounded text-black">
                                            <p className="mb-0">
                                                Webcam: {webcamOn ? <i className='bx bxs-camera' ></i> : <i className='bx bxs-camera-off' ></i>}
                                                Microphone {micOn ? <i className='bx bxs-microphone'></i> : <i className='bx bxs-microphone-off'></i>}
                                            </p>
                                        </div>
                                    <audio ref={micRef} autoPlay playsInline muted={isLocal} />


                                    <div className="col-md-12 ">
                                        {!isLocal &&
                                            <button id={`btn_getimage_${props.participantId}`} className="btn btn-info btn-sm h-100 w-100" style={{ maxWidth: "217px" }} onClick={() => { imageCaptureAffiant(displayName, props.participantId, props.adminBase64Image); }}>Recapture Affiant Image</button>
                                        } 
                                    </div>



                                </div>
                            </div>
                        </div>
                    </div>

                }

            </div>
        </>
    );
    

}
 
export default ParticipantView;